import Vue from 'vue';
import Meta from 'vue-meta';
import '@/filter/index';
import reportData from '@/api/report';
import customPlugin from '@/plugin/index';
import { ReportDataPlugin, PLATFORM } from '@/plugin/report_data_plugin';
import App from './App.vue';
import { createRouter } from './router/ssr-router';
import store from './store';
// import { append, on } from './util/invokeHelper';

export function createApp(ssrContext) {
  Vue.use(Meta, {
    keyName: 'head',
    attribute: 'data-n-head',
    ssrAttribute: 'data-n-head-ssr',
    tagIDKeyName: 'headId',
  });
  if (!Vue.installedServerPlugin) { // 服务端渲染会重复加载插件，导致内存泄漏，这里做一次判断
    Vue.installedServerPlugin = true;
    Vue.use(customPlugin);
    Vue.reportData = reportData;
    Vue.use(ReportDataPlugin, { platform: PLATFORM.h5 });
  }
  const router = createRouter();
  const app = new Vue({
    // the root instance simply renders the App component.
    router,
    store,
    head: {
      // 目前只支持Object格式
      __dangerouslyDisableSanitizers: ['script'],
    },
    ssrContext,
    ...App,
  });
  return { app, router, store };
}



// WEBPACK FOOTER //
// ../src/app.js